export default "__VITE_ASSET__bYVD612E__"